let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5pnOk")).then(() => parcelRequire('irqA2'));